import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class ProductService {

    getEventRoute = '/api/user/';

    constructor(private dataService: DataService) {
    };

    // getProductList(refresh: boolean){
    //     return this.dataService.getData('/api/product/getproductlist',refresh);
    // }
    getProductList(provider: boolean) {
        return this.dataService.getRecord('/api/product/getproductlist/' + provider);
    }
    getProductLists(kimberley, provider, isOWCP, isOWSP) {
        return this.dataService.getRecord('/api/product/getproductlist/' + kimberley + '/' + provider + '/' + isOWCP + '/' + isOWSP);
    }
    getzoomProductList(refresh: boolean) {
        return this.dataService.getData('/api/product/getZoomproductlist', refresh);
    }

    getProductListView(refresh: boolean) {
        return this.dataService.getData('/api/product/getProductListView', refresh);
    }

    getProductByApplicationId(applicationId) {
        return this.dataService.getRecord('/api/product/getproductbyapplicationid/' + applicationId);
    }

    getAllProductsForDropDown(refresh: boolean) {
        return this.dataService.getData('/api/product/getAllProductsForDropDown', refresh);
    }

    getOpenServeAppDataForRenewVoucher(appId) {
        return this.dataService.getRecord('/api/application/getOpenServeAppDataForRenewVoucher/' + appId);
    }

    getZoomPortalProductId(actualProductId: number) {
        return this.dataService.getRecord('/api/zoom/GetZoomPortalProductId/' + actualProductId)
    }
}

